// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firestoreEnviroment: 'env/dev',
  firebase 	: {
  	apiKey: "AIzaSyAREXei5Qfnn-55JNCt7jMQr10z4WoFUBw",
    authDomain: "royal-agentes-admin.firebaseapp.com",
    databaseURL: "https://royal-agentes-admin.firebaseio.com",
    projectId: "royal-agentes-admin",
    storageBucket: "royal-agentes-admin.appspot.com",
    messagingSenderId: "53190602311"
  },
  firestoreSetting: {
  	timestampsInSnapshots: true
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
